import { __exportAll } from "../../_virtual/rolldown_runtime.mjs";
import { Jwk, JwkId } from "./sui/rpc/v2/jwk.mjs";
import { Ability, DatatypeDescriptor, DatatypeDescriptor_DatatypeKind, FieldDescriptor, FunctionDescriptor, FunctionDescriptor_Visibility, Linkage, Module, OpenSignature, OpenSignatureBody, OpenSignatureBody_Type, OpenSignature_Reference, Package, TypeOrigin, TypeParameter, VariantDescriptor } from "./sui/rpc/v2/move_package.mjs";
import { Owner, Owner_OwnerKind } from "./sui/rpc/v2/owner.mjs";
import { Bcs } from "./sui/rpc/v2/bcs.mjs";
import { Display, Object as Object$1, ObjectSet } from "./sui/rpc/v2/object.mjs";
import { Argument, Argument_ArgumentKind } from "./sui/rpc/v2/argument.mjs";
import { FundsWithdrawal, FundsWithdrawal_Source, Input, Input_InputKind, Input_Mutability } from "./sui/rpc/v2/input.mjs";
import { ObjectReference } from "./sui/rpc/v2/object_reference.mjs";
import { ActiveJwk, AuthenticatorStateExpire, AuthenticatorStateUpdate, CanceledTransaction, ChangeEpoch, Command, ConsensusCommitPrologue, ConsensusDeterminedVersionAssignments, EndOfEpochTransaction, EndOfEpochTransactionKind, EndOfEpochTransactionKind_Kind, ExecutionTimeObservation, ExecutionTimeObservation_ExecutionTimeObservationKind, ExecutionTimeObservations, GasPayment, GenesisTransaction, MakeMoveVector, MergeCoins, MoveCall, ProgrammableTransaction, Publish, RandomnessStateUpdate, SplitCoins, SystemPackage, Transaction, TransactionExpiration, TransactionExpiration_TransactionExpirationKind, TransactionKind, TransactionKind_Kind, TransferObjects, Upgrade, ValidatorExecutionTimeObservation, VersionAssignment } from "./sui/rpc/v2/transaction.mjs";
import { BalanceChange } from "./sui/rpc/v2/balance_change.mjs";
import { GasCostSummary } from "./sui/rpc/v2/gas_cost_summary.mjs";
import { CleverError, CoinDenyListError, CommandArgumentError, CommandArgumentError_CommandArgumentErrorKind, CongestedObjects, ExecutionError, ExecutionError_ExecutionErrorKind, ExecutionStatus, IndexError, MoveAbort, MoveLocation, PackageUpgradeError, PackageUpgradeError_PackageUpgradeErrorKind, SizeError, TypeArgumentError, TypeArgumentError_TypeArgumentErrorKind } from "./sui/rpc/v2/execution_status.mjs";
import { AccumulatorWrite, AccumulatorWrite_AccumulatorOperation, AccumulatorWrite_AccumulatorValue, ChangedObject, ChangedObject_IdOperation, ChangedObject_InputObjectState, ChangedObject_OutputObjectState, EventDigestEntry, TransactionEffects, UnchangedConsensusObject, UnchangedConsensusObject_UnchangedConsensusObjectKind } from "./sui/rpc/v2/effects.mjs";
import { Event, TransactionEvents } from "./sui/rpc/v2/event.mjs";
import { SignatureScheme } from "./sui/rpc/v2/signature_scheme.mjs";
import { CircomG1, CircomG2, MultisigAggregatedSignature, MultisigCommittee, MultisigMember, MultisigMemberPublicKey, MultisigMemberSignature, PasskeyAuthenticator, SimpleSignature, UserSignature, ValidatorAggregatedSignature, ValidatorCommittee, ValidatorCommitteeMember, ZkLoginAuthenticator, ZkLoginClaim, ZkLoginInputs, ZkLoginProof, ZkLoginPublicIdentifier } from "./sui/rpc/v2/signature.mjs";
import { ExecutedTransaction } from "./sui/rpc/v2/executed_transaction.mjs";
import { CommandOutput, CommandResult, ExecuteTransactionRequest, ExecuteTransactionResponse, SimulateTransactionRequest, SimulateTransactionRequest_TransactionChecks, SimulateTransactionResponse, TransactionExecutionService } from "./sui/rpc/v2/transaction_execution_service.mjs";
import { ProtocolConfig } from "./sui/rpc/v2/protocol_config.mjs";
import { MoveTable, StakeSubsidy, StakingPool, StorageFund, SystemParameters, SystemState, Validator, ValidatorReportRecord, ValidatorSet } from "./sui/rpc/v2/system_state.mjs";
import { Epoch } from "./sui/rpc/v2/epoch.mjs";
import { AddressAliasesVersion, CheckpointContents, CheckpointedTransactionInfo } from "./sui/rpc/v2/checkpoint_contents.mjs";
import { CheckpointCommitment, CheckpointCommitment_CheckpointCommitmentKind, CheckpointSummary, EndOfEpochData } from "./sui/rpc/v2/checkpoint_summary.mjs";
import { Checkpoint } from "./sui/rpc/v2/checkpoint.mjs";
import { BatchGetObjectsRequest, BatchGetObjectsResponse, BatchGetTransactionsRequest, BatchGetTransactionsResponse, GetCheckpointRequest, GetCheckpointResponse, GetEpochRequest, GetEpochResponse, GetObjectRequest, GetObjectResponse, GetObjectResult, GetServiceInfoRequest, GetServiceInfoResponse, GetTransactionRequest, GetTransactionResponse, GetTransactionResult, LedgerService } from "./sui/rpc/v2/ledger_service.mjs";
import { GetDatatypeRequest, GetDatatypeResponse, GetFunctionRequest, GetFunctionResponse, GetPackageRequest, GetPackageResponse, ListPackageVersionsRequest, ListPackageVersionsResponse, MovePackageService, PackageVersion } from "./sui/rpc/v2/move_package_service.mjs";
import { SignatureVerificationService, VerifySignatureRequest, VerifySignatureResponse } from "./sui/rpc/v2/signature_verification_service.mjs";
import { Balance, CoinMetadata, CoinMetadata_MetadataCapState, CoinTreasury, CoinTreasury_SupplyState, DynamicField, DynamicField_DynamicFieldKind, GetBalanceRequest, GetBalanceResponse, GetCoinInfoRequest, GetCoinInfoResponse, ListBalancesRequest, ListBalancesResponse, ListDynamicFieldsRequest, ListDynamicFieldsResponse, ListOwnedObjectsRequest, ListOwnedObjectsResponse, RegulatedCoinMetadata, RegulatedCoinMetadata_CoinRegulatedState, StateService } from "./sui/rpc/v2/state_service.mjs";
import { SubscribeCheckpointsRequest, SubscribeCheckpointsResponse, SubscriptionService } from "./sui/rpc/v2/subscription_service.mjs";
import { LookupNameRequest, LookupNameResponse, NameRecord, NameService, ReverseLookupNameRequest, ReverseLookupNameResponse } from "./sui/rpc/v2/name_service.mjs";
import { AdvanceCheckpointRequest, AdvanceCheckpointResponse, AdvanceClockRequest, AdvanceClockResponse, ForkingService, GetStatusRequest, GetStatusResponse } from "./sui/forking/v1alpha/forking_service.mjs";
import { ErrorReason } from "./sui/rpc/v2/error_reason.mjs";

//#region src/grpc/proto/types.ts
var types_exports = /* @__PURE__ */ __exportAll({
	Ability: () => Ability,
	AccumulatorWrite: () => AccumulatorWrite,
	AccumulatorWrite_AccumulatorOperation: () => AccumulatorWrite_AccumulatorOperation,
	AccumulatorWrite_AccumulatorValue: () => AccumulatorWrite_AccumulatorValue,
	ActiveJwk: () => ActiveJwk,
	AddressAliasesVersion: () => AddressAliasesVersion,
	AdvanceCheckpointRequest: () => AdvanceCheckpointRequest,
	AdvanceCheckpointResponse: () => AdvanceCheckpointResponse,
	AdvanceClockRequest: () => AdvanceClockRequest,
	AdvanceClockResponse: () => AdvanceClockResponse,
	Argument: () => Argument,
	Argument_ArgumentKind: () => Argument_ArgumentKind,
	AuthenticatorStateExpire: () => AuthenticatorStateExpire,
	AuthenticatorStateUpdate: () => AuthenticatorStateUpdate,
	Balance: () => Balance,
	BalanceChange: () => BalanceChange,
	BatchGetObjectsRequest: () => BatchGetObjectsRequest,
	BatchGetObjectsResponse: () => BatchGetObjectsResponse,
	BatchGetTransactionsRequest: () => BatchGetTransactionsRequest,
	BatchGetTransactionsResponse: () => BatchGetTransactionsResponse,
	Bcs: () => Bcs,
	CanceledTransaction: () => CanceledTransaction,
	ChangeEpoch: () => ChangeEpoch,
	ChangedObject: () => ChangedObject,
	ChangedObject_IdOperation: () => ChangedObject_IdOperation,
	ChangedObject_InputObjectState: () => ChangedObject_InputObjectState,
	ChangedObject_OutputObjectState: () => ChangedObject_OutputObjectState,
	Checkpoint: () => Checkpoint,
	CheckpointCommitment: () => CheckpointCommitment,
	CheckpointCommitment_CheckpointCommitmentKind: () => CheckpointCommitment_CheckpointCommitmentKind,
	CheckpointContents: () => CheckpointContents,
	CheckpointSummary: () => CheckpointSummary,
	CheckpointedTransactionInfo: () => CheckpointedTransactionInfo,
	CircomG1: () => CircomG1,
	CircomG2: () => CircomG2,
	CleverError: () => CleverError,
	CoinDenyListError: () => CoinDenyListError,
	CoinMetadata: () => CoinMetadata,
	CoinMetadata_MetadataCapState: () => CoinMetadata_MetadataCapState,
	CoinTreasury: () => CoinTreasury,
	CoinTreasury_SupplyState: () => CoinTreasury_SupplyState,
	Command: () => Command,
	CommandArgumentError: () => CommandArgumentError,
	CommandArgumentError_CommandArgumentErrorKind: () => CommandArgumentError_CommandArgumentErrorKind,
	CommandOutput: () => CommandOutput,
	CommandResult: () => CommandResult,
	CongestedObjects: () => CongestedObjects,
	ConsensusCommitPrologue: () => ConsensusCommitPrologue,
	ConsensusDeterminedVersionAssignments: () => ConsensusDeterminedVersionAssignments,
	DatatypeDescriptor: () => DatatypeDescriptor,
	DatatypeDescriptor_DatatypeKind: () => DatatypeDescriptor_DatatypeKind,
	Display: () => Display,
	DynamicField: () => DynamicField,
	DynamicField_DynamicFieldKind: () => DynamicField_DynamicFieldKind,
	EndOfEpochData: () => EndOfEpochData,
	EndOfEpochTransaction: () => EndOfEpochTransaction,
	EndOfEpochTransactionKind: () => EndOfEpochTransactionKind,
	EndOfEpochTransactionKind_Kind: () => EndOfEpochTransactionKind_Kind,
	Epoch: () => Epoch,
	ErrorReason: () => ErrorReason,
	Event: () => Event,
	EventDigestEntry: () => EventDigestEntry,
	ExecuteTransactionRequest: () => ExecuteTransactionRequest,
	ExecuteTransactionResponse: () => ExecuteTransactionResponse,
	ExecutedTransaction: () => ExecutedTransaction,
	ExecutionError: () => ExecutionError,
	ExecutionError_ExecutionErrorKind: () => ExecutionError_ExecutionErrorKind,
	ExecutionStatus: () => ExecutionStatus,
	ExecutionTimeObservation: () => ExecutionTimeObservation,
	ExecutionTimeObservation_ExecutionTimeObservationKind: () => ExecutionTimeObservation_ExecutionTimeObservationKind,
	ExecutionTimeObservations: () => ExecutionTimeObservations,
	FieldDescriptor: () => FieldDescriptor,
	ForkingService: () => ForkingService,
	FunctionDescriptor: () => FunctionDescriptor,
	FunctionDescriptor_Visibility: () => FunctionDescriptor_Visibility,
	FundsWithdrawal: () => FundsWithdrawal,
	FundsWithdrawal_Source: () => FundsWithdrawal_Source,
	GasCostSummary: () => GasCostSummary,
	GasPayment: () => GasPayment,
	GenesisTransaction: () => GenesisTransaction,
	GetBalanceRequest: () => GetBalanceRequest,
	GetBalanceResponse: () => GetBalanceResponse,
	GetCheckpointRequest: () => GetCheckpointRequest,
	GetCheckpointResponse: () => GetCheckpointResponse,
	GetCoinInfoRequest: () => GetCoinInfoRequest,
	GetCoinInfoResponse: () => GetCoinInfoResponse,
	GetDatatypeRequest: () => GetDatatypeRequest,
	GetDatatypeResponse: () => GetDatatypeResponse,
	GetEpochRequest: () => GetEpochRequest,
	GetEpochResponse: () => GetEpochResponse,
	GetFunctionRequest: () => GetFunctionRequest,
	GetFunctionResponse: () => GetFunctionResponse,
	GetObjectRequest: () => GetObjectRequest,
	GetObjectResponse: () => GetObjectResponse,
	GetObjectResult: () => GetObjectResult,
	GetPackageRequest: () => GetPackageRequest,
	GetPackageResponse: () => GetPackageResponse,
	GetServiceInfoRequest: () => GetServiceInfoRequest,
	GetServiceInfoResponse: () => GetServiceInfoResponse,
	GetStatusRequest: () => GetStatusRequest,
	GetStatusResponse: () => GetStatusResponse,
	GetTransactionRequest: () => GetTransactionRequest,
	GetTransactionResponse: () => GetTransactionResponse,
	GetTransactionResult: () => GetTransactionResult,
	IndexError: () => IndexError,
	Input: () => Input,
	Input_InputKind: () => Input_InputKind,
	Input_Mutability: () => Input_Mutability,
	Jwk: () => Jwk,
	JwkId: () => JwkId,
	LedgerService: () => LedgerService,
	Linkage: () => Linkage,
	ListBalancesRequest: () => ListBalancesRequest,
	ListBalancesResponse: () => ListBalancesResponse,
	ListDynamicFieldsRequest: () => ListDynamicFieldsRequest,
	ListDynamicFieldsResponse: () => ListDynamicFieldsResponse,
	ListOwnedObjectsRequest: () => ListOwnedObjectsRequest,
	ListOwnedObjectsResponse: () => ListOwnedObjectsResponse,
	ListPackageVersionsRequest: () => ListPackageVersionsRequest,
	ListPackageVersionsResponse: () => ListPackageVersionsResponse,
	LookupNameRequest: () => LookupNameRequest,
	LookupNameResponse: () => LookupNameResponse,
	MakeMoveVector: () => MakeMoveVector,
	MergeCoins: () => MergeCoins,
	Module: () => Module,
	MoveAbort: () => MoveAbort,
	MoveCall: () => MoveCall,
	MoveLocation: () => MoveLocation,
	MovePackageService: () => MovePackageService,
	MoveTable: () => MoveTable,
	MultisigAggregatedSignature: () => MultisigAggregatedSignature,
	MultisigCommittee: () => MultisigCommittee,
	MultisigMember: () => MultisigMember,
	MultisigMemberPublicKey: () => MultisigMemberPublicKey,
	MultisigMemberSignature: () => MultisigMemberSignature,
	NameRecord: () => NameRecord,
	NameService: () => NameService,
	Object: () => Object$1,
	ObjectReference: () => ObjectReference,
	ObjectSet: () => ObjectSet,
	OpenSignature: () => OpenSignature,
	OpenSignatureBody: () => OpenSignatureBody,
	OpenSignatureBody_Type: () => OpenSignatureBody_Type,
	OpenSignature_Reference: () => OpenSignature_Reference,
	Owner: () => Owner,
	Owner_OwnerKind: () => Owner_OwnerKind,
	Package: () => Package,
	PackageUpgradeError: () => PackageUpgradeError,
	PackageUpgradeError_PackageUpgradeErrorKind: () => PackageUpgradeError_PackageUpgradeErrorKind,
	PackageVersion: () => PackageVersion,
	PasskeyAuthenticator: () => PasskeyAuthenticator,
	ProgrammableTransaction: () => ProgrammableTransaction,
	ProtocolConfig: () => ProtocolConfig,
	Publish: () => Publish,
	RandomnessStateUpdate: () => RandomnessStateUpdate,
	RegulatedCoinMetadata: () => RegulatedCoinMetadata,
	RegulatedCoinMetadata_CoinRegulatedState: () => RegulatedCoinMetadata_CoinRegulatedState,
	ReverseLookupNameRequest: () => ReverseLookupNameRequest,
	ReverseLookupNameResponse: () => ReverseLookupNameResponse,
	SignatureScheme: () => SignatureScheme,
	SignatureVerificationService: () => SignatureVerificationService,
	SimpleSignature: () => SimpleSignature,
	SimulateTransactionRequest: () => SimulateTransactionRequest,
	SimulateTransactionRequest_TransactionChecks: () => SimulateTransactionRequest_TransactionChecks,
	SimulateTransactionResponse: () => SimulateTransactionResponse,
	SizeError: () => SizeError,
	SplitCoins: () => SplitCoins,
	StakeSubsidy: () => StakeSubsidy,
	StakingPool: () => StakingPool,
	StateService: () => StateService,
	StorageFund: () => StorageFund,
	SubscribeCheckpointsRequest: () => SubscribeCheckpointsRequest,
	SubscribeCheckpointsResponse: () => SubscribeCheckpointsResponse,
	SubscriptionService: () => SubscriptionService,
	SystemPackage: () => SystemPackage,
	SystemParameters: () => SystemParameters,
	SystemState: () => SystemState,
	Transaction: () => Transaction,
	TransactionEffects: () => TransactionEffects,
	TransactionEvents: () => TransactionEvents,
	TransactionExecutionService: () => TransactionExecutionService,
	TransactionExpiration: () => TransactionExpiration,
	TransactionExpiration_TransactionExpirationKind: () => TransactionExpiration_TransactionExpirationKind,
	TransactionKind: () => TransactionKind,
	TransactionKind_Kind: () => TransactionKind_Kind,
	TransferObjects: () => TransferObjects,
	TypeArgumentError: () => TypeArgumentError,
	TypeArgumentError_TypeArgumentErrorKind: () => TypeArgumentError_TypeArgumentErrorKind,
	TypeOrigin: () => TypeOrigin,
	TypeParameter: () => TypeParameter,
	UnchangedConsensusObject: () => UnchangedConsensusObject,
	UnchangedConsensusObject_UnchangedConsensusObjectKind: () => UnchangedConsensusObject_UnchangedConsensusObjectKind,
	Upgrade: () => Upgrade,
	UserSignature: () => UserSignature,
	Validator: () => Validator,
	ValidatorAggregatedSignature: () => ValidatorAggregatedSignature,
	ValidatorCommittee: () => ValidatorCommittee,
	ValidatorCommitteeMember: () => ValidatorCommitteeMember,
	ValidatorExecutionTimeObservation: () => ValidatorExecutionTimeObservation,
	ValidatorReportRecord: () => ValidatorReportRecord,
	ValidatorSet: () => ValidatorSet,
	VariantDescriptor: () => VariantDescriptor,
	VerifySignatureRequest: () => VerifySignatureRequest,
	VerifySignatureResponse: () => VerifySignatureResponse,
	VersionAssignment: () => VersionAssignment,
	ZkLoginAuthenticator: () => ZkLoginAuthenticator,
	ZkLoginClaim: () => ZkLoginClaim,
	ZkLoginInputs: () => ZkLoginInputs,
	ZkLoginProof: () => ZkLoginProof,
	ZkLoginPublicIdentifier: () => ZkLoginPublicIdentifier
});

//#endregion
export { types_exports };
//# sourceMappingURL=types.mjs.map